module.exports = __webpack_public_path__ + "assets/img/ddbes_time.5157b0ce.png";